import styled from 'styled-components';

export const SubscriptionNamesList = styled.ul`
  color: inherit;
  margin: ${({ theme }) => theme.space[2]}px 0;
  padding-left: ${({ theme }) => theme.space[7]}px;
`;
